import { Link as RouterLink } from 'react-router-dom';
import { Box, Text, Image, Skeleton } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import BottomTabHome from '../../assets/icons/BottomTabHome';
import BottomTabPractice from '../../assets/icons/BottomTabPractice';
import BottomTabCreate from '../../assets/icons/BottomTabCreate';
import BottomTabApply from '../../assets/icons/BottomtabApply';
import { useNavigate } from 'react-router-dom';
import { useAssessmentToken } from '../../../context/AssessmentTokenContext';
import { navLinkData } from './LeftNav';
import { sendTrackingEvent } from '../../../utils/gtm';

const BottomTabNavbar = () => {
	const navigate = useNavigate();

	const { selectedRoadmapPublishedItemId } = useAssessmentToken();
	useEffect(() => {
		console.log('selectedRoadmapPublishedItemId:', selectedRoadmapPublishedItemId);
	}, [selectedRoadmapPublishedItemId]);
	return (
		<Box
			width={'100%'}
			h="56px"
			boxShadow={'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'}
			position={'fixed'}
			bottom={'0px'}
			bgColor={'white'}
			display={'grid'}
			gap="32px"
			px="30px"
			gridTemplateColumns={'repeat(4, 1fr)'}
			justifyContent={'center'}
			justifyItems={'center'}
			// alignItems={'center'}
		>
			{navLinkData.map(({ tabName, icon, url, active }, index) => {
				return (
					<Box
						w="48px"
						py="8px"
						to={url}
						key={index}
						as={RouterLink}
						display={'flex'}
						justifyContent={'center'}
						flexDirection={'column'}
						color={active() ? '#4358F6' : '#0A0103'}
						onClick={() => {
							if (tabName == 'Home') {
								sendTrackingEvent({
									event: 'cnd_home',
									eventLabel: window.location.href,
								});
							} else if (tabName == 'Practice') {
								sendTrackingEvent({
									event: 'cnd_practice',
									eventLabel: window.location.href,
								});
							} else if (tabName == 'Resume') {
								sendTrackingEvent({
									event: 'cnd_resume',
									eventLabel: window.location.href,
								});
							} else if (tabName == 'Apply') {
								sendTrackingEvent({
									event: 'cnd_apply',
									eventLabel: window.location.href,
								});
							}
						}}
					>
						<Box mx="auto" justifyContent={'center'}>
							{icon}
						</Box>
						<Text mt="2px" mx="auto" textStyle="body1" fontSize={'10px'} fontWeight={400} lineHeight={'14px'}>
							{tabName}
						</Text>
					</Box>
				);
			})}
		</Box>
	);
};

export default BottomTabNavbar;
